import report from 'plugins/i18n/entity/report.en.ts'
import person from '../entity/person.en.ts'
import updaterequest from 'plugins/i18n/entity/updaterequest.en.ts'
import meter from 'plugins/i18n/entity/meter.en.ts'
import meterLevel from 'plugins/i18n/entity/meterLevel.en.ts'
import craftsman_task from 'plugins/i18n/entity/craftsmanTask.en.ts'
import task from 'plugins/i18n/entity/task.en.ts'
import cis from 'plugins/i18n/entity/cis.en.ts'
import document from 'plugins/i18n/entity/document.en.ts'
import comment from 'plugins/i18n/entity/comment.en.ts'
import email from 'plugins/i18n/entity/email.en.ts'
import address from 'plugins/i18n/entity/address.en.ts'
import notification from 'plugins/i18n/entity/notification.en.ts'
import note from 'plugins/i18n/entity/note.en.ts'
import role from 'plugins/i18n/entity/role.en.ts'
import phonenumber from 'plugins/i18n/entity/phonenumber.en.ts'
import building from 'plugins/i18n/entity/building.en.ts'
import unit from 'plugins/i18n/entity/unit.en.ts'
import handoverProtocol from 'plugins/i18n/entity/handoverProtocol.en.ts'
import documenttype from 'plugins/i18n/entity/documenttype.en.ts'
import permission from 'plugins/i18n/entity/permission.en.ts'
import team from 'plugins/i18n/entity/team.en.ts'
import review_document from 'plugins/i18n/entity/reviewDocument.en.ts'
import journal from 'plugins/i18n/entity/journal.en.ts'
import sync from 'plugins/i18n/entity/sync.en.ts'
import user from 'plugins/i18n/entity/user.en.ts'
import invoice from 'plugins/i18n/entity/invoice.en.ts'
import account from 'plugins/i18n/entity/account.en.ts'
import ticket from 'plugins/i18n/entity/ticket.en.ts'
import faq from 'plugins/i18n/entity/faq.en.ts'
import handovertemplate from 'plugins/i18n/entity/handovertemplate.en.ts'
import notestype from 'plugins/i18n/entity/notestype.en.ts'
import reportType from 'plugins/i18n/entity/reportType.en.ts'
import reportStatus from 'plugins/i18n/entity/reportStatus.en.ts'
import personsaccount from 'plugins/i18n/entity/personsAccount.en.ts'
import readable from 'plugins/i18n/entity/readable.en.ts'
import sync_failure from 'plugins/i18n/entity/syncFailure.en.ts'
import sync_update_reason from 'plugins/i18n/entity/syncUpdateReason.en.ts'
import person_access_rejection from 'plugins/i18n/entity/personAccessRejection.en.ts'

const entity = {
	address,
	building,
	craftsman_task,
	cis,
	comment,
	document,
	documenttype,
	email,
	notification,
	note,
	task,
	team,
	person,
	report,
	role,
	updaterequest,
	meter,
	meterLevel,
	phonenumber,
	unit,
	handoverProtocol,
	permission,
	review_document,
	journal,
	sync,
	user,
	invoice,
	account,
	ticket,
	faq,
	handovertemplate,
	notestype,
	reportType,
	reportStatus,
	personsaccount,
	readable,
	sync_failure,
	sync_update_reason,
	person_access_rejection,
}

export default entity
